import { useRef, useState } from 'react';

/** Event handlers read immediately; rendering observes the same snapshot via state. */
export function useSnapshotState<S>(initial: S) {
  const [snapshot, setSnapshot] = useState<S>(() => initial);
  const snapshotRef = useRef(initial);
  const updateSnapshot = (next: S) => {
    snapshotRef.current = next;
    setSnapshot(() => next);
  };
  return { snapshot, snapshotRef, updateSnapshot };
}
